module.exports = __webpack_public_path__ + "img/wanderSaneStamp.e9f1774e.svg";